export default {
    /**
     * Flag indicating to load only references which could only have one target instead of all.
     */
    loadOnlyToOneReferences: false, //true,
    /**
     * Flag indicating to load all references instead of visible ones only.
     * Setting to true has performance impact!
     */
    loadAllReferences: false,
    /**
     * Flag indicating to load all properties instead of visible ones only.
     * Setting to true has performance impact!
     */
    loadAllProperties: false,

    /**
     * The valueTypes for which the search will be marked in rendering
     */
    markSearchInValueTypes: [ 'JSON', 'STRING', 'TEXT' ],

    /**
     * The number of references or enum properties to show in the rendering.
     */
    maxRefsOrEnumPropsToShowCount: 10
};
